import CheckResultRuntime from "packages/helpers/CheckResultRuntime";
import { ResultWithError } from "packages/errors/errors";
import { del } from "packages/rest/api";
import { SessionRaw, SessionRuntime } from "../model";

export async function SignOutAPI():Promise<ResultWithError<SessionRaw>> {
    const res = await del({url: "session"});
    return CheckResultRuntime(SessionRuntime, res);
}
